import ContainerCard from '../../../../common/components/ContainerCard';
import styles from './PaymentMethodsSection.module.css';
import styles2 from '../../AccountPage.module.css';

type PaymentMethodsProps = {
  address: string;
};

const PaymentMethods = (props: PaymentMethodsProps) => {
  return (
    <ContainerCard className={styles2.cardDimensions}>
      <div className={styles.title}>PAYMENT METHODS</div>
      <hr className={styles.divider} />
      <a className={styles.linkBlue} href={props.address} target='_blank'>
        Manage Credit Cards
      </a>
    </ContainerCard>
  );
};

export default PaymentMethods;
